import { useMemo } from "react";
import { useScope } from "@state/scopeContext.lib";
import type { SendingOwner } from "@api/sendingOwner";

export function useWorkspaceSendingOwner(): SendingOwner | null {
    const { workspaceId } = useScope();
    return useMemo(() => (workspaceId ? { workspaceId } : null), [workspaceId]);
}
